import cn from 'classnames';
import { Cell, ClickableIcon, IconEditFilled, type TestProps, VStack } from '@direct-frontend/components';
import { TextCopy } from '../TextCopy';
import { SettingsBlockRow, type SettingsBlockRowProps } from './SettingsBlockRow';
import styles from './SettingsBlockRow.module.css';

export interface SettingsBlockRowCopyProps extends SettingsBlockRowProps, TestProps {
    copyValue?: string;
    onChange?: () => void;
    isEditable?: boolean;
}

export function SettingsBlockRowCopy({
    copyValue,
    content,
    onChange,
    isEditable = true,
    'data-testid': dataTestId = 'SettingsBlockRow',
    ...props
}: SettingsBlockRowCopyProps) {
    const penCell =
        onChange && isEditable ? (
            <Cell type="Icon" className={styles.icon}>
                <VStack>
                    <ClickableIcon data-testid={`${dataTestId}.Icon`} role="supplementary" onClick={onChange}>
                        <IconEditFilled size="20" />
                    </ClickableIcon>
                </VStack>
            </Cell>
        ) : null;

    if (!content) {
        return (
            <SettingsBlockRow content={content} data-testid={dataTestId} {...props}>
                {penCell}
            </SettingsBlockRow>
        );
    }

    return (
        <SettingsBlockRow
            {...props}
            data-testid={dataTestId}
            className={cn(props.isContentTruncated && styles.row_truncated)}
            content={{
                title: (textProps) => (
                    <TextCopy {...textProps} isFullWidth title={copyValue} copyText={copyValue}>
                        {typeof content.title === 'string' ? content.title : content.title(textProps)}
                    </TextCopy>
                ),
                caption: content?.caption,
            }}
        >
            {penCell}
        </SettingsBlockRow>
    );
}
